import { useMemo } from "react";
import { useFetchers, Fetcher } from "react-router-dom";
import { ActivateResult } from "../../actions/explore/activate/activate";
import { ReturnResult } from "../../actions/explore/return/return";
import { getBasePathWithTrailingSlash } from "../../../../common/env";

export default function useExploreFetcher(asset?: VST.Bridge.Asset) {
  const activateFetcher: Fetcher<ActivateResult> | undefined =
    useFetchers().find(
      (fetcher) =>
        fetcher.formAction ===
        `${getBasePathWithTrailingSlash()}actions/activate/${asset?.vbid}`
    );

  const returnFetcher: Fetcher<ReturnResult> | undefined = useFetchers().find(
    (fetcher) =>
      fetcher.formAction ===
      `${getBasePathWithTrailingSlash()}actions/return/${asset?.vbid}`
  );

  const activeFetcher = useMemo(
    () => activateFetcher ?? returnFetcher,
    [activateFetcher, returnFetcher]
  );

  const returnComplete = useMemo(
    () =>
      !!returnFetcher &&
      returnFetcher.state === "loading" &&
      returnFetcher.data?.ok,
    [returnFetcher]
  );

  const returnError = useMemo(
    () =>
      !!returnFetcher &&
      returnFetcher.state === "loading" &&
      !returnFetcher.data?.ok,
    [returnFetcher]
  );

  const activationComplete = useMemo(
    () =>
      !!activateFetcher &&
      activateFetcher.state === "loading" &&
      activateFetcher.data?.ok,
    [activateFetcher]
  );

  return { activeFetcher, returnComplete, activationComplete, returnError };
}
